import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import CloseIcon from '../../../assets/images/common/modals/close.svg';
import NewFiltersItem from './NewFiltersItem';

function NewFilterModal({ handleClose,
    handleClearAll,
    filters,
    addToFilters,
    removeFromFilters,
    selectedFilters,
    handleApply }) {
    useEffect(() => {
        document.querySelector('body').classList.add('overflow-hidden');
        return () => {
            document.querySelector('body').classList.remove('overflow-hidden');
        }
    }, []);
    const hasSelectedFilters = selectedFilters && !!Object.keys(selectedFilters).length;
    return (<div className="default-modal filter-modal">
        <div className="default-modal__backdrop">
            <div className="default-modal__container">
                <div className="default-modal__header">
                    <p className="default-modal__header__title">Filters</p>
                    <button onClick={handleClose} className="default-modal__header__close">
                        <img src={CloseIcon} alt="close modal" />
                    </button>
                </div>
                <div className="default-modal__content">
                    <NewFiltersItem filters={filters}
                        selectedFilters={selectedFilters}
                        removeFromFilters={removeFromFilters}
                        addToFilters={addToFilters} />
                </div>
                <div className="default-modal__footer">
                    <button onClick={handleClearAll}
                        disabled={!hasSelectedFilters}
                        className={`default-modal__footer__clear-btn
                            ${hasSelectedFilters ? '' : 'default-modal__footer__clear-btn--disabled'}`}>
                        <span className="default-modal__footer__clear-btn__text">Clear All</span>
                    </button>
                    <button onClick={handleApply} className="default-modal__footer__action-btn
                        default-modal__footer__action-btn--primary">
                        <span className="default-modal__footer__action-btn__text">Apply</span>
                    </button>
                </div>
            </div>
        </div>
    </div>)
};

NewFilterModal.propTypes = {
    handleApply: PropTypes.func,
    handleClearAll: PropTypes.func,
    handleClose: PropTypes.func,
    filters: PropTypes.array,
    selectedFilters: PropTypes.object,
    addToFilters: PropTypes.func,
    removeFromFilters: PropTypes.func
}

export default NewFilterModal;